import React from 'react';
import styled from '@benzinga/themetron';
import { CircularChart } from '@benzinga/charts-ui';

interface SectionRatingProps {
  up: number;
  down: number;
  className?: string;
}

const SectionRating: React.FC<SectionRatingProps> = ({ className, down, up }) => {
  const trackColor = up / (up + down) > 0.5 ? '#30BF60' : '#FF4050';
  const circularChartBackgroundColor = up / (up + down) > 0.5 ? '#143233' : '#432734';
  const textColor = up / (up + down) > 0.5 ? '#0F993D' : '#FF4050';
  const value = (up / (up + down)) * 100;

  return (
    <SectionRatingWrapper className={className}>
      <CircularChart
        backgroundColor={circularChartBackgroundColor}
        indicatorColor={trackColor}
        textColor={textColor}
        trackColor={circularChartBackgroundColor}
        value={value}
      />
    </SectionRatingWrapper>
  );
};

export default SectionRating;

const SectionRatingWrapper = styled.div`
  .percentage-text {
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
  }
`;
